export const GET_MEDICAL_BILL_BY_HOSPITALID_REQUEST =
  "GET_MEDICAL_BILL_BY_HOSPITALID_REQUEST";
export const GET_MEDICAL_BILL_BY_HOSPITALID_SUCCESS =
  "GET_MEDICAL_BILL_BY_HOSPITALID_SUCCESS";
export const GET_MEDICAL_BILL_BY_HOSPITALID_FAILURE =
  "GET_MEDICAL_BILL_BY_HOSPITALID_FAILURE";

export const REQUEST_HEALTH_INSURANCE_CARD = "REQUEST_HEALTH_INSURANCE_CARD";
export const REQUEST_HEALTH_INSURANCE_CARD_SUCCESS =
  "REQUEST_HEALTH_INSURANCE_CARD_SUCCESS";
export const REQUEST_HEALTH_INSURANCE_CARD_FAIL =
  "REQUEST_HEALTH_INSURANCE_CARD_FAIL";

export const SELECTED_HEALTH_INSURANCE_TO_SHOWM_MODAL =
  "SELECTED_HEALTH_INSURANCE_TO_SHOWM_MODAL";
export const SELECTED_HEALTH_INSURANCE_TO_SHOWM_RESEND_SMS_MODAL =
  "SELECTED_HEALTH_INSURANCE_TO_SHOWM_RESEND_SMS_MODAL";

export const TOGGLE_MODAL_HEALTH_INSURANCE_CARD =
  "TOGGLE_MODAL_HEALTH_INSURANCE_CARD";
export const TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD =
  "TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD";

export const SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD =
  "SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD";
export const HIDE_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD =
  "HIDE_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD";

/* ######################## */

export const GET_ALL_PAYMENT_METHODS = "GET_ALL_PAYMENT_METHODS";
export const GET_ALL_PAYMENT_METHODS_SUCCESS =
  "GET_ALL_PAYMENT_METHODS_SUCCESS";
export const GET_ALL_PAYMENT_METHODS_FAIL = "GET_ALL_PAYMENT_METHODS_FAIL";

export const TOGGLE_MODAL_PAYMENT_METHOD = "TOGGLE_MODAL_PAYMENT_METHOD";
export const HIDE_MODAL_PAYMENT_METHOD = "HIDE_MODAL_PAYMENT_METHOD";
export const RESET_ALL_PROPS_PAYMENT_METHOD = "RESET_ALL_PROPS_PAYMENT_METHOD";
export const SELECTED_PAYMENT_METHOD = "SELECTED_PAYMENT_METHOD";

export const GET_ALL_PAYMENT_METHOD_FEE = "GET_ALL_PAYMENT_METHOD_FEE";
export const GET_ALL_PAYMENT_METHOD_CSKH = "GET_ALL_PAYMENT_METHOD_CSKH";

export const CHECK_REQUIRE_PAYMENT = "CHECK_REQUIRE_PAYMENT";

export const RESET_PAYMENT = "RESET_PAYMENT";

export const SET_PRICE_OF_SERVICE_ADD_ON = "SET_PRICE_OF_SERVICE_ADD_ON";
export const RESET_PRICE_PAYMENT = "RESET_PRICE_PAYMENT";

export const STOP_GET_STATUS_TRANSACTION = "STOP_GET_STATUS_TRANSACTION";
export const GET_STATUS_TRANSACTION = "GET_STATUS_TRANSACTION";
export const ACTIVE_STATUS_TRANSACTION = "ACTIVE_STATUS_TRANSACTION";

export const GET_ALL_PAYMEN_MULTI_BOOKING_METHODS =
  "GET_ALL_PAYMEN_MULTI_BOOKING_METHODS";
export const GET_ALL_PAYMEN_MULTI_BOOKING_METHODS_SUCCESS =
  "GET_ALL_PAYMEN_MULTI_BOOKING_METHODS_SUCCESS";
